export default __webpack_public_path__ + "static/media/medical-business-suite.a38582c5.svg";